import axios from 'axios';
import $ from 'jquery';
import TomSelect from 'tom-select';
import Quill from 'quill';
import moment from 'moment';
// import 'tempusdominus-bootstrap-4';

// Expose libraries globally (legacy compatibility)
window.axios = axios;
window.$ = window.jQuery = $;
window.TomSelect = TomSelect;
window.Quill = Quill;
window.moment = moment;

// Default headers
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;$.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': csrfToken
        }
    });
}

require('tempusdominus-bootstrap-4');
